export default "__VITE_ASSET__Db2sZy35__"